export default "__VITE_ASSET__DhO1wkJs__"